import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Erfolgsmeldung({ titel, text, zurueckPfad = '/' }) {
  const navigate = useNavigate();

  return (
    <div className="form-container">
      <div className="success-container">
        <div className="success-icon">✓</div>
        <h2 className="success-title">{titel}</h2>
        <p className="success-text">{text}</p>
        <button
          onClick={() => navigate(zurueckPfad)}
          className="submit-btn"
          style={{ marginTop: '1.5rem', maxWidth: 260 }}
        >
          ← Zurück zur Übersicht
        </button>
      </div>
    </div>
  );
}
